/**
 * LOP Product Tabs Showcase
 * - Tabs
 * - Desktop: drag-to-scroll on flat card track, snap per card
 * - Mobile: 2 products visible, scroll-snap advances 1 card per swipe
 * - Dots: informational only, updated on scroll
 */
(function () {
    'use strict';
  
    function enableMouseDrag(track) {
      if (track._lopDrag) return;
      track._lopDrag = true;

      var isDown = false;
      var hasMoved = false;
      var startX, scrollStart;
      var animId = 0;

      var prevX = 0;
      var prevTime = 0;
      var velocity = 0;

      function stopCoast() {
        if (animId) { cancelAnimationFrame(animId); animId = 0; }
      }

      track.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        stopCoast();
        isDown = true;
        hasMoved = false;
        startX = e.pageX;
        prevX = e.pageX;
        prevTime = Date.now();
        velocity = 0;
        scrollStart = track.scrollLeft;
        track.style.cursor = 'grabbing';
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
      });

      track.addEventListener('mouseleave', end);
      track.addEventListener('mouseup', end);

      function end() {
        if (!isDown) return;
        isDown = false;
        track.style.cursor = '';

        if (!hasMoved || Math.abs(velocity) < 0.3) {
          track.style.scrollSnapType = '';
          track.style.scrollBehavior = '';
          return;
        }

        var friction = 0.95;
        var v = velocity;

        function coast() {
          v *= friction;
          if (Math.abs(v) < 0.5) {
            animId = 0;
            track.style.scrollSnapType = '';
            track.style.scrollBehavior = '';
            return;
          }
          track.scrollLeft -= v;
          var maxSl = track.scrollWidth - track.clientWidth;
          if (track.scrollLeft <= 0 || track.scrollLeft >= maxSl) {
            animId = 0;
            track.style.scrollSnapType = '';
            track.style.scrollBehavior = '';
            return;
          }
          animId = requestAnimationFrame(coast);
        }
        animId = requestAnimationFrame(coast);
      }

      track.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var walk = e.pageX - startX;
        if (Math.abs(walk) > 4) hasMoved = true;
        track.scrollLeft = scrollStart - walk;

        var now = Date.now();
        var dt = now - prevTime;
        if (dt > 0) {
          velocity = (e.pageX - prevX) / dt * 16;
        }
        prevX = e.pageX;
        prevTime = now;
      });

      track.addEventListener('click', function (e) {
        if (hasMoved) {
          e.stopPropagation();
          e.preventDefault();
          hasMoved = false;
        }
      }, true);

      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    }
  
    function setupUnifiedDots(panel) {
      var dotsWrap = panel.querySelector('.lop-tabs-unified-dots');
      if (!dotsWrap || dotsWrap._lopUnified) return;
      dotsWrap._lopUnified = true;

      var dots = dotsWrap.querySelectorAll('.lop-tabs-unified-dot');
      if (!dots.length) return;

      var mobileTrack = panel.querySelector('.lop-tabs-showcase__track--mobile');
      var desktopTrack = panel.querySelector('.lop-tabs-desktop-carousel__track');

      function getVisibleTrack() {
        var dv = panel.querySelector('.lop-tabs-view--desktop');
        if (dv && dv.offsetWidth > 0) return desktopTrack;
        return mobileTrack;
      }

      function maxScroll(track) {
        return track.scrollWidth - track.clientWidth;
      }

      function cardStep(track) {
        var cards = track.querySelectorAll('.lop-tabs-desktop-carousel__card, .lop-tabs-mobile-card');
        if (cards.length < 2) return 200;
        return cards[1].offsetLeft - cards[0].offsetLeft;
      }

      function activeDotIndex(track) {
        var ms = maxScroll(track);
        if (ms <= 0) return 0;
        var sl = track.scrollLeft;
        if (sl <= 2) return 0;
        if (sl >= ms - 2) return 2;
        return 1;
      }

      function updateDots() {
        var track = getVisibleTrack();
        if (!track) return;
        var ms = maxScroll(track);
        if (ms <= 0) { dotsWrap.style.display = 'none'; return; }
        dotsWrap.style.display = '';
        var idx = activeDotIndex(track);
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }

      function scrollByOne(direction) {
        var track = getVisibleTrack();
        if (!track) return;
        var step = cardStep(track);
        track.scrollLeft += step * direction;
      }

      // Dot 0 (left) = go back 1 card, dot 2 (right) = go forward 1 card
      dots[0].addEventListener('click', function () { scrollByOne(-1); });
      dots[2].addEventListener('click', function () { scrollByOne(1); });

      var t;
      function onScroll() { clearTimeout(t); t = setTimeout(updateDots, 60); }
      if (mobileTrack) mobileTrack.addEventListener('scroll', onScroll);
      if (desktopTrack) desktopTrack.addEventListener('scroll', onScroll);

      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt); rt = setTimeout(updateDots, 150);
      });

      updateDots();
    }
  
    function initSlidersInRoot(root) {
      requestAnimationFrame(function () {
        root.querySelectorAll('.lop-tabs-showcase__panel:not([hidden]) .lop-tabs-desktop-carousel__track').forEach(enableMouseDrag);
        root.querySelectorAll('.lop-tabs-showcase__panel:not([hidden])').forEach(setupUnifiedDots);
      });
    }
  
    function initLopTabsShowcase(root) {
      if (!root || root.dataset.lopInit === '1') return;
      root.dataset.lopInit = '1';
  
      var tabs = root.querySelectorAll('.lop-tabs-showcase__tab');
      var panels = root.querySelectorAll('.lop-tabs-showcase__panel');
  
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t, j) {
            var on = j === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.setAttribute('tabindex', on ? '0' : '-1');
            panels[j].hidden = !on;
          });
          initSlidersInRoot(root);
        });
      });
  
      initSlidersInRoot(root);
    }
  
    function initAll() {
      document.querySelectorAll('.lop-tabs-showcase').forEach(initLopTabsShowcase);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  
    if (!window.__lopTabsBound) {
      window.__lopTabsBound = true;
      document.addEventListener('shopify:section:load', function (e) {
        if (e.target && e.target.querySelectorAll) {
          e.target.querySelectorAll('.lop-tabs-showcase').forEach(initLopTabsShowcase);
        }
      });
    }
  })();
  